import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { ApolloProvider } from 'react-apollo';
import store, { history,  sagaMiddleware } from './store';
import rootSaga from './sagas';
import { client } from './apollo';
import 'react-dates/initialize';
// import Gtm from './Gtm';
import Layout from './components/Layout';

export default class App extends React.Component {
  render() {
    sagaMiddleware.run(rootSaga);
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ApolloProvider client={client}>
            <Layout />
          </ApolloProvider>
        </ConnectedRouter>
      </Provider>
    );
  }
};



// WEBPACK FOOTER //
// ./src/App.js